
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { SecureAdminAuthProvider } from "@/hooks/useSecureAdminAuth";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BreadcrumbNav from "./components/navigation/BreadcrumbNav";
import { AppRouter } from "./router/AppRouter";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary context="App">
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SecureAdminAuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <div className="min-h-screen flex flex-col w-full">
                <Header />
                <BreadcrumbNav />
                <main className="flex-1">
                  <AppRouter />
                </main>
                <Footer />
              </div>
            </BrowserRouter>
          </TooltipProvider>
        </SecureAdminAuthProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
